/**
 * State
 */
export abstract class State extends PIXI.Container {
    protected _size: PIXI.Point;

    constructor() {
        super();
        this._size = new PIXI.Point();
    }

    /**
     * Inits state
     * @param pSize
     */
    public init(pSize: PIXI.Point, pData?: any): void {
        this.onResize(pSize);
    }

    /**
     * Animates in
     * @param pOnComplete
     */
    public animateIn(pOnComplete: () => void): void {
        pOnComplete();
    }

    /**
     * Updates state
     * @param pDeltaTime
     */
    public update(pDeltaTime: number): void {
        // override
    }

    /**
     * Determines whether resize on
     * @param pSize
     */
    public onResize(pSize: PIXI.Point): void {
        this._size.copy(pSize);
        this.position.set(this._size.x * 0.5, this._size.y * 0.5);
    }

    /**
     * Animates out
     * @param pOnComplete
     */
    public animateOut(pOnComplete: () => void): void {
        pOnComplete();
    }

    /**
     * Destroys state.
     * @param pOptions
     */
    public destroy(pOptions: boolean | PIXI.DestroyOptions = { children: true }): void {
        super.destroy(pOptions);
    }
}
